import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService, GRSSResponse } from 'src/app/_services/app.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  isCurrentPasswordVisible: boolean = false;
  isNewPasswordVisible: boolean = false;
  changePassword: PasswordForm;

  constructor(private service: AppService, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private dialog: MatDialog) {
    this.service.SetTranslation('tools/password');
   }

  ngOnInit() {
    this.InitializeForm();
  }

  /** Initializes the form */
  InitializeForm() {
    this.changePassword = {
      currentPassword: '',
      newConfirmPassword: '',
      newPassword: '',
      userId: ''
    }
  }

  /** Click event for the save button */
  OnSavePassword() {
    if (this.changePassword.currentPassword !== '' && this.changePassword.newConfirmPassword !== '' && this.changePassword.newPassword !== '') {
      this.http.post<GRSSResponse>(this.baseUrl + 'api/auth/changePasswordTools', this.changePassword).subscribe(result => {
        if (result.statusCode === 4) {
          this.service.SaveStatus(true, 'Password.header', result.statusMessage);
        } else {
          if (result.statusCode === 1) {
            this.InitializeForm();
            this.isCurrentPasswordVisible = false;
            this.isNewPasswordVisible = false;
          }
          this.service.SaveStatus(false, 'Password.header', result.statusMessage);
        }
      });
    }
  }

}

/** An interface to access the values in the password form */
interface PasswordForm {
  userId: string;
  currentPassword: string;
  newPassword: string;
  newConfirmPassword: string;
}